import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=528fb59a&scoped=true&"
import script from "./detailList.vue?vue&type=script&lang=js&"
export * from "./detailList.vue?vue&type=script&lang=js&"
import style0 from "./detailList.vue?vue&type=style&index=0&id=528fb59a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528fb59a",
  null
  
)

export default component.exports